import Cookies from 'js-cookie';
// docs https://github.com/js-cookie/js-cookie

// Read allow analytics cookie before setting Google Analytics

export default function() {


  
      let cookieBannerClicked = Cookies.get('allowanalytics');

      if(!cookieBannerClicked) {
        document.querySelector('.js-cookie-banner').style.display = 'block';
      }
      
      document.querySelector('.js-reopen-cookie-banner').addEventListener("click", function(e) {
        e.preventDefault()
        document.querySelector('.js-cookie-banner').style.display = 'block';
      });

      if(document.querySelector('.js-close-cookie-banner')) {
          document.querySelector('.js-close-cookie-banner').addEventListener("click", function(e) {
          e.preventDefault()
          Cookies.set('allowanalytics', 'true', { expires: 365 });
          document.querySelector('.js-cookie-banner').style.display = 'none';
        });
      }
      
    if(document.querySelector('.js-accept-cookies')) {
      document.querySelector('.js-accept-cookies').addEventListener("click", function(e) {
        e.preventDefault()
        Cookies.set('allowanalytics', 'true', { expires: 365 });
        document.querySelector('.js-cookie-banner').style.display = 'none';
      });
    }
    if(document.querySelector('.js-decline-cookies')) {
      document.querySelector('.js-decline-cookies').addEventListener("click", function(e) {
        e.preventDefault()
        Cookies.set('allowanalytics', 'false', { expires: 365 });
        document.querySelector('.js-cookie-banner').style.display = 'none';
      });
    }
   
  
}